import { render, staticRenderFns } from "./ToastsQueue.vue?vue&type=template&id=308ce6a5&scoped=true&"
import script from "./ToastsQueue.vue?vue&type=script&lang=ts&"
export * from "./ToastsQueue.vue?vue&type=script&lang=ts&"
import style0 from "./ToastsQueue.vue?vue&type=style&index=0&id=308ce6a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ce6a5",
  null
  
)

export default component.exports